import { Swiper } from "swiper";
import { Navigation } from "swiper/modules";

/** Collection button with collection index in data attribute */
export interface CollectionButtonElement extends HTMLElement {
  dataset: DOMStringMap & { collectionIndex?: string };
}

/** Tab panel with collection URL in data attribute */
export interface CollectionPanelElement extends HTMLElement {
  dataset: DOMStringMap & { collectionIndex?: string; collectionUrl?: string };
}

/** View-all link that gets its href updated per collection */
export interface ViewAllButtonElement extends HTMLAnchorElement {
  href: string;
}

class JollyProductList extends HTMLElement {
  selectedIndex = 0;

  get panels(): NodeListOf<CollectionPanelElement> {
    return this.querySelectorAll<CollectionPanelElement>(
      ".product-list__panel"
    );
  }

  get collectionButtons(): NodeListOf<CollectionButtonElement> {
    return this.querySelectorAll<CollectionButtonElement>(
      ".product-list__collection-button"
    );
  }

  get viewAllButtons(): NodeListOf<ViewAllButtonElement> {
    return this.querySelectorAll<ViewAllButtonElement>(
      ".product-list__view-all-button"
    );
  }

  connectedCallback() {
    this.initProductCarousels();
    this.collectionButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.collectionButtons[this.selectedIndex]?.classList.remove("selected");
        this.selectedIndex = Number(btn.dataset.collectionIndex) ?? 0;
        this.collectionButtons[this.selectedIndex]?.classList.add("selected");
        this.switchToPanel(this.selectedIndex);
        const url =
          this.panels[this.selectedIndex]?.dataset.collectionUrl ?? "";
        this.viewAllButtons.forEach((btnViewAll) => {
          btnViewAll.href = url;
        });
      });
    });
  }

  private switchToPanel(index: number): void {
    this.panels.forEach((panel, i) => {
      if (i === index) {
        panel.setAttribute("data-active", "");
      } else {
        panel.removeAttribute("data-active");
      }
    });
  }

  private initProductCarousels(): void {
    const productCarouselSwiper = this.querySelectorAll(
      ".product-carousel-swiper"
    );

    if (productCarouselSwiper) {
      productCarouselSwiper.forEach((swiperEl) => {
        new Swiper(swiperEl as HTMLElement, {
          modules: [Navigation],
          speed: 800,
          slidesPerView: 4,
          spaceBetween: 24,
          navigation: {
            nextEl: `#${swiperEl.id} .slide-navigation__next`,
            prevEl: `#${swiperEl.id} .slide-navigation__prev`,
          },
        });
      });
    }
  }
}

customElements.define("jolly-product-list", JollyProductList);
